import { frontendURL } from '../../../helper/URLHelper';

const IaCampaignsView = () => import('./IaCampaignsView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/disparos-ia'),
    name: 'ia_campaigns_dashboard',
    meta: {
      permissions: ['administrator'],
    },
    component: IaCampaignsView,
  },
];
